module.exports = __webpack_public_path__ + "static/img13-e3acf878035e11772981850ce67120f4.jpg";